import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TUserMessageProps = {
  children: ReactNode;
  className?: string;
};

export function UserMessage({ children, className }: TUserMessageProps) {
  return (
    <div
      className={cn(
        "flex w-full items-center justify-end bg-innoveraGeneral-white py-[12px]",
        className
      )}
    >
      <div
        className="flex max-w-[292px] flex-col items-end gap-[6px] rounded-[8px] rounded-br-[2px] bg-innoveraZinc-100 px-[14px] py-[10px]"
      >
        <div className="flex w-full flex-col items-start gap-[6px] text-[14px] leading-[22px] text-innoveraZinc-900">
          {children}
        </div>
      </div>
    </div>
  );
}
